import React from 'react';
import {
   Filter, TextInput,
} from 'react-admin';

const UsersFilter = (props) => (
   <Filter {...props}>
      <TextInput label="Username" source="username" alwaysOn />
   </Filter>
);

export default UsersFilter;
